export enum EUserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  MEMBER = 'MEMBER',
  VIEWER = 'VIEWER',
  MARKETING = 'MARKETING',
}

export enum EOnlineStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface IUserProfileStats {
  totalUsers: number
  completedProfiles: number
  incompleteProfiles: number
  todayUpdated: number
}

export interface ILoginStatisticsSummary {
  totalLogins: number
  uniqueUsers: number
  todayLogins: number
  onlineUsers: number
}

export interface IPeriodTotal {
  totalLogins: number
  uniqueUsers: number
  avgLoginPerUser: number
  newUsers: number
}
